/* unplugin-vue-components disabled */import { render } from "./mainMenuNavigationItem.vue?vue&type=template&id=36eba23d&scoped=true"
import script from "./mainMenuNavigationItem.vue?vue&type=script&lang=js"
export * from "./mainMenuNavigationItem.vue?vue&type=script&lang=js"

import "./mainMenuNavigationItem.vue?vue&type=style&index=0&id=36eba23d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36eba23d"]])

export default __exports__